<template>
  <sg-spacing :b-sm="divider" :b-xs="spaced" :class="divider && 'border-b border-b-200'">
    <sg-font :tag="tag" v-bind="[colorProps, variantProps, primaryProps]">
      <slot />
    </sg-font>
  </sg-spacing>
</template>

<script>
export default {
  props: {
    tag: { type: String, default: 'h1' },

    primary: Boolean,
    secondary: Boolean,
    tertiary: Boolean,

    lightNavy: Boolean,
    navy: Boolean,
    darkNavy: Boolean,
    lightGray: Boolean,
    gray: Boolean,
    darkGray: Boolean,
    black: Boolean,
    white: Boolean,

    divider: Boolean,
    spaced: Boolean,

    bold: Boolean,
    center: Boolean,
    ellipsis: Boolean,
    italic: Boolean,
    medium: Boolean,
    underline: Boolean,
    uppercase: Boolean,
  },

  computed: {
    colorProps() {
      if (this.lightNavy) return { lightNavy: true };
      if (this.navy) return { navy: true };
      if (this.darkNavy) return { darkNavy: true };
      if (this.lightGray) return { lightGray: true };
      if (this.gray) return { gray: true };
      if (this.darkGray) return { darkGray: true };
      if (this.black) return { black: true };
      if (this.white) return { white: true };
    },
    primaryProps() {
      if (this.primary) return { sizeXxxl: true, leadLoose: true, bold: true };
      if (this.secondary) return { sizeXxl: true, leadLoose: true, bold: true };
      if (this.tertiary) return { sizeXl: true, leadLoose: true, medium: true };
    },
    variantProps() {
      return {
        bold: this.bold,
        center: this.center,
        ellipsis: this.ellipsis,
        italic: this.italic,
        medium: this.medium,
        underline: this.underline,
        uppercase: this.uppercase,
      };
    },
  },
};
</script>
